import { useState, useEffect } from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import Sidebar from "./sidebar";
import Header from "./header";
import { Breadcrumb, BreadcrumbItem, BackToContext } from "./breadcrumb";

interface ResponsiveLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  currentPage?: string;
  breadcrumbs?: BreadcrumbItem[];
  backTo?: BackToContext;
  isLoading?: boolean;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

function ResponsiveLayout({ children, title, subtitle, currentPage, breadcrumbs, backTo, isLoading, icon, actions }: ResponsiveLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isMobile = useIsMobile();

  // Close sidebar when switching to mobile
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [isMobile]);

  const handleMenuToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar 
        isOpen={sidebarOpen || !isMobile} 
        onClose={isMobile ? handleSidebarClose : undefined}
      />
      
      <div className={`flex-1 transition-all duration-300 ${
        !isMobile ? 'ml-64' : 'ml-0'
      }`}>
        <Header 
          title={title} 
          subtitle={subtitle}
          currentPage={currentPage}
          onMenuToggle={isMobile ? handleMenuToggle : undefined}
          icon={icon}
          pageActions={actions}
        />
        
        <main className="p-4 sm:p-6">
          <Breadcrumb items={breadcrumbs} backTo={backTo} isLoading={isLoading} />
          {children}
        </main>
      </div>
    </div>
  );
}

export default ResponsiveLayout;
export { ResponsiveLayout };